import { COLORS } from "./colors";

export const styles = {
  boxShadows: {
    customDarks: {
      4: `0px 4px 4px 0px ${COLORS.darks[0][6]}`,
    },
    darks: {
      4: `4px 4px 10px ${COLORS.darks[0][25]}`,
      6: `0px 12px 26px 0px ${COLORS.darks[0][6]}`,
    },
    purples: {
      10: `0px 12px 26px 0px ${COLORS.purples[10]}`,
    },
  },
};
